import React from "react";
import "./DateFilterStyleSheet.css";
import './ArtistFilterStyleSheet.css';
interface DateRangeFilterProps {
    from?: string | null; // "YYYY-MM-DD"
    to?: string | null;
    onChange: (from: string | null, to: string | null) => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
    from,
    to,
    onChange,
}) => {
    const handleFromChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value || null;
        onChange(value, to ?? null);
    };

    const handleToChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value || null;
        onChange(from ?? null, value);
    };

    const clear = () => onChange(null, null);

    const hasValue = !!from || !!to;

    return (
        <div className="filter-section">
            <div className="filter-section-header">
                {hasValue && (
                    <button
                        type="button"
                        className="filter-clear-btn"
                        onClick={clear}
                    >
                        Clear
                    </button>
                )}
            </div>

            <div className="date-range-row">
                <div className="date-input-wrapper">
                    <label className="date-label">From</label>
                    <input
                        type="date"
                        value={from ?? ""}
                        onChange={handleFromChange}
                        className="date-input"
                    />
                </div>
                <div className="date-input-wrapper">
                    <label className="date-label">To</label>
                    <input
                        type="date"
                        value={to ?? ""}
                        onChange={handleToChange}
                        className="date-input"
                    />
                </div>
            </div>
        </div>
    );
};
